import { createContext, useContext, useState, useEffect } from 'react';

const AdminContext = createContext(null);

export const AdminProvider = ({ children }) => {
  const [adminToken, setAdminToken] = useState(null);
  const [adminUser, setAdminUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('zindal_admin_token');
    const user = localStorage.getItem('zindal_admin_user');
    if (token) setAdminToken(token);
    if (user) setAdminUser(JSON.parse(user));
  }, []);

  const adminLogin = (token, user) => {
    setAdminToken(token);
    setAdminUser(user);
    localStorage.setItem('zindal_admin_token', token);
    localStorage.setItem('zindal_admin_user', JSON.stringify(user));
  };

  const adminLogout = () => {
    setAdminToken(null);
    setAdminUser(null);
    localStorage.removeItem('zindal_admin_token');
    localStorage.removeItem('zindal_admin_user');
  };

  const value = {
    adminToken,
    adminUser,
    isAdmin: !!adminToken,
    adminLogin,
    adminLogout
  };

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
};

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within AdminProvider');
  }
  return context;
};
